import { LayerProps } from 'react-map-gl'

const icons = [
  {
    name: 'marker',
    href: '/markers/marker.png',
  },
  {
    name: 'markerSelected',
    href: '/markers/marker-selected.png',
  },
]

export const loadIconsUtils = (mapCurrent, resolve, reject) => {
  for (let i = 0; i < icons.length; i++) {
    const element = icons[i]
    const name = element['name']
    const href = `/${process.env.SITE}/${element['href']}`

    if (!mapCurrent.hasImage(name)) {
      mapCurrent.loadImage(href, (error, image) => {
        if (error) {
          reject(error)
        } else {
          if (!mapCurrent.hasImage(name)) {
            mapCurrent.addImage(name, image)
          }
          resolve()
        }
      })
    }
  }
}

const MAINCOLORS = {
  5: '#178115',
  6: '#178115',
}

export const clusterLayer: LayerProps = {
  id: 'clusters',
  type: 'circle',
  source: 'rivenditori',
  filter: ['has', 'point_count'],
  paint: {
    'circle-color': MAINCOLORS[process.env.SITE_ID],
    'circle-radius': 24,
  },
}

export const clusterCountLayer: LayerProps = {
  id: 'cluster-count',
  type: 'symbol',
  source: 'rivenditori',
  filter: ['has', 'point_count'],
  layout: {
    'text-field': '{point_count_abbreviated}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 16,
  },
  paint: {
    'text-color': '#ffffff',
  },
}

export const unclusteredPointGetIconLayer: LayerProps = {
  id: 'unclustered-point',
  type: 'symbol',
  source: 'rivenditori',
  filter: ['!', ['has', 'point_count']],
  layout: {
    'icon-image': ['get', 'icon'],
    'icon-allow-overlap': true,
  },
}
